import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export default function useReloadLocationOnClick(onReset: Function) {
  const [lastClickedTime, setLastClickedTime] = useState()
  const { state } = useLocation()

  useEffect(() => {
    if (state?.clickedAt && lastClickedTime !== state.clickedAt) {
      setLastClickedTime(state.clickedAt)
      onReset?.()
      window.scrollTo(0, 0)
    }
    return () => {
      setLastClickedTime(undefined)
    }
  }, [state])
}
